import { rgb, shade } from "polished";
import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  .tele-viewbox:where(*) {
    margin: 0;
    font-family: "Versos", sans-serif;
    font-weight: 500;
    line-height: 1.5;
  }

  .tele-viewbox:where(*::-webkit-scrollbar) {
    width: 8px;
    background-color: #f5f5f5;
  }

  .tele-viewbox:where(*::-webkit-scrollbar-thumb) {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
    box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
    background-color: ${(props) => props.theme.colors.secondary};
  }

  .tele-viewbox:where(*::-webkit-scrollbar-track) {
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
    box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
    border-radius: 10px;
    background-color: #f5f5f5;
  }
  
  .swal2-container {
    z-index: 99999 !important;
    .swal2-popup {
      .swal2-title {
        font-size: 26px;
      }
    }

    &.swal2-top > .swal2-popup {
      display: flex !important;
      align-items: center;
      width: 90%;
      max-width: fit-content;
      padding: 0;
      border: 1px solid #6d318f;

      &.error {
        display: flex !important;
        background: rgb(255, 38, 38);
        padding: 5px 10px;
        .swal2-icon {
          width: 20px;
        }
        .swal2-html-container {
          color: #f5f5f5;
          font-size: 12px;
          height: 100%;
          display: flex;
          align-items: center;
        }
        &.swal2-toast .swal2-actions button {
          background-color: ${shade(0.2, rgb(255, 38, 38))};
        }
      }
      &.success {
        display: flex !important;
        background: rgb(56, 228, 76);
        padding: 5px 10px;
        .swal2-icon {
          width: 20px;
        }
        .swal2-html-container {
          color: #f5f5f5;
          font-size: 12px;
          height: 100%;
          display: flex;
          align-items: center;
        }
        &.swal2-toast .swal2-actions button {
          background-color: ${shade(0.2, rgb(56, 228, 76))};
        }
      }
      &.swal2-toast .swal2-actions {
        margin: 0 !important;
      }
    }
  }

  .swal2-popup.swal2-toast .swal2-html-container {
    padding: 10px 15px;
    margin: 0;
    text-align: center;
    .toast-text {
      display: block;
      display: -webkit-box;
      max-height: 150px;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;
